<script>
import { BFormInput } from "bootstrap-vue"

export default {
  components: {
    BFormInput,
  },
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    decimals: {
      type: Number,
      default: 2,
    },
    horizontal: {
      default: false,
      type: Boolean,
    },
    label: {
      default: "",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    size: {
      default: "md",
      type: String,
    },
    type: {
      default: "text",
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "input"],
  data() {
    return {
      isInputActive: false,
    }
  },
  computed: {
    displayValue: {
      get() {
        let numberdec = 2
        if (
          Number.isNaN(this.decimals)
          || this.decimals === null
          || this.decimals === ""
        ) {
          numberdec = 2
        } else {
          numberdec = Number.parseFloat(this.decimals)
        }
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return Number.isNaN(this.modelValue)
            || this.modelValue === null
            || this.modelValue === ""
            ? 0
            : this.modelValue.toString().replace(".", ",")
        } else {
          return Number.isNaN(this.modelValue)
            || this.modelValue === null
            || this.modelValue === ""
            ? this.modelValue
            : this.decimalToRussianF(this.modelValue, numberdec)
        }
      },
      set(modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = Number.parseFloat(
          modifiedValue.replace(",", ".").replace(/[^.0-9a-z]/gi, ""),
        )
        // Ensure that it is not NaN
        if (Number.isNaN(newValue)) {
          newValue = 0
        }
        // Note: we cannot set this.modelValue as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit("update:modelValue", newValue)
        this.$emit("input", newValue)
      },
    },
  },
  methods: {
    onlyNumber(event) {
      const char = String.fromCharCode(event.keyCode || event.which)

      if (!/[0-9,.]/.test(char)) {
        event.preventDefault()
      }
    },
    decimalToRussianF(value, fraction) {
      const number = value
      return new Intl.NumberFormat("ru-RU", {
        maximumFractionDigits: fraction,
        minimumFractionDigits: fraction,
      }).format(number)
    },
  },
}
</script>

<template>
  <div>
    <BFormInput
      v-model="displayValue"
      :horizontal="horizontal"
      :label="label"
      :disabled="disabled"
      class="mb-0 CurrenyInput"
      :type="type"
      :placeholder="placeholder"
      @blur="isInputActive = false"
      @focus="isInputActive = true"
      @keypress="onlyNumber"
    />
  </div>
</template>

<style>
.CurrenyInput input {
  text-align: right;
}
</style>
